const index = {
    state: {
        campaign_id: null,
        selectedFacility: {},
        bank_deposit_date_from: '',
        bank_deposit_date_to: '',
        bankDepositMatchedTotal: 0,
        depositMatchedTotal: 0,
        depositMatchListCsv: [],
        bankDepositMatchListCsv: [],
        showMatches: true,
        bankDepositListBack: [],
        paymentTypeId: 0,
        bankDepositTotal: 0,
        bankDepositAppliedTotal: 0,
        depositAppliedTotal: 0,
        editing: false
    },
    getters: {
        campaign_id: () => {
            return state.campaign_id;
        },
        bank_deposit_date_from: () => {
            return state.selectedFacility;
        },
        bank_deposit_date_to: () => {
            return state.selectedFacility;
        },
        bankDepositMatchedTotal: () => {
            return state.bankDepositMatchedTotal;
        },
        depositMatchedTotal: () => {
            return state.depositMatchedTotal;
        },
        depositMatchListCsv: () => {
            return state.depositMatchListCsv;
        },
        bankDepositMatchListCsv: () => {
            return state.bankDepositMatchListCsv;
        },
        showMatches: () => {
            return state.bankDepositMatchListCsv;
        },
        bankDepositListBack: () => {
            return state.bankDepositListBack;
        },
        paymentTypeId: () => {
            return state.bankDepositListBack;
        },
        bankDepositTotal: () => {
            return state.bankDepositTotal;
        },
        bankDepositAppliedTotal: () => {
            return state.bankDepositAppliedTotal;
        },
        depositAppliedTotal: () => {
            return state.depositAppliedTotal;
        },
        editing: () => {
            return state.editing;
        },
    },
    mutations: {
        set_campaign_id: (state, payload) => (state.campaign_id = payload),
        setSelectedFacility: (state, payload) => (state.selectedFacility = payload),
        set_bank_deposit_date_from: (state, payload) => (state.bank_deposit_date_from = payload),
        set_bank_deposit_date_to: (state, payload) => (state.bank_deposit_date_to = payload),
        setDepositMatchedTotal: (state, payload) => (state.depositMatchedTotal = payload),
        setBankDepositMatchedTotal: (state, payload) => (state.bankDepositMatchedTotal = payload),
        setDepositMatchListCsv: (state, payload) => (state.depositMatchListCsv = payload),
        setBankDepositMatchListCsv: (state, payload) => (state.bankDepositMatchListCsv = payload),
        setShowMatches: (state, payload) => (state.showMatches = payload),
        setBankDepositListBack: (state, payload) => (state.bankDepositListBack = payload),
        setPaymentTypeId: (state, payload) => (state.paymentTypeId = payload),
        setBankDepositTotal: (state, payload) => (state.bankDepositTotal = payload),
        setBankDepositAppliedTotal: (state, payload) => (state.bankDepositAppliedTotal = payload),
        setDepositAppliedTotal: (state, payload) => (state.depositAppliedTotal = payload),
        setEditing: (state, payload) => (state.editing = payload),

    }
}

export default index;

